<template>
  <NuxtLayout name="default">
    <template #menu>
      <quiz-editor-block-menu />
    </template>
    <quiz-editor-quiz-content />
  </NuxtLayout>
</template>

<script lang="ts">
import { provide } from "vue"

import { useQuizEditorStore } from "~/stores/quizEditorStore"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    const quizEditorStore = useQuizEditorStore()

    provide("editorStore", quizEditorStore)

    definePageMeta({
      layout: false,
    })

    return { userStore, quizEditorStore }
  },

  computed: {
    hasValidRole(): boolean {
      return ["admin", "content_admin", "content_creator", "field_leader"].includes(
        this.userStore.current?.role
      )
    },
  },

  watch: {
    "quizEditorStore.loading"(loading: boolean) {
      if (!loading && this.quizEditorStore.published && this.$route.query.preview !== "true" && this.userStore.current?.role !== "admin") {
        navigateTo("/")
      }
    },
  },

  created() {
    if (!this.hasValidRole) {
      navigateTo("/")
      return
    }

    const quizId = this.$route.params.quizId as string
    this.quizEditorStore.fetchQuiz(quizId)
  },

  mounted() {
    window.hideBeacon()
  },

  beforeUnmount() {
    window.unhideBeacon()
  },
}
</script>
